import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', label: 'Home', icon: '🏠' },
    { path: '/#about', label: 'About', icon: '👤' },
    { path: '/web-design-services', label: 'Web Design', icon: '🎨' },
    { path: '/classic-games', label: 'Classic Games', icon: '🎮' },
    { path: '/task-list', label: 'Task List', icon: '📝' },
    { path: '/daily-planner', label: 'Daily Planner', icon: '📅' },
    { path: '/#contact', label: 'Connect', icon: '📧' }
  ];

  const handleNavClick = (path: string) => {
    setIsMenuOpen(false);

    if (path.startsWith('/#')) {
      const sectionId = path.substring(2);

      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link
          to="/"
          className="nav-logo"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setIsMenuOpen(false);
          }}
        >
          <span className="logo-text">Portfolio</span>
          <span className="logo-accent">.</span>
        </Link>

        <button
          className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => {
            const isAnchorLink = item.path.startsWith('/#');

            return (
              <li key={item.path} className="nav-item">
                {isAnchorLink ? (
                  <a
                    href={item.path}
                    className={`nav-link ${location.pathname === '/' && location.hash === item.path.substring(1) ? 'active' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(item.path);
                    }}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.label}</span>
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.label}</span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;